"use client";

import React, { useLayoutEffect, useState } from "react";
import { ChatbotProvider } from "./ChatbotContext";
import { EmbeddedChatbotBlock } from "./EmbeddedChatbotBlock";
import { EmbeddedChatbotBlockPopup } from "./EmbeddedChatbotBlockPopup";
import { EmbeddedChatbotFallback } from "./EmbeddedChatbotFallback";
import {
  ChatbotDisabledEmbedded,
  ChatbotDisabledEmbeddedPopup,
} from "./ChatbotDisabled";

export function EmbeddedChatbot({
  isPopup,
  ...props
}: React.ComponentProps<typeof EmbeddedChatbotBlock> & {
  isPopup?: boolean;
}) {
  const [isDisabled, setIsDisabled] = useState<boolean | null>(null);

  useLayoutEffect(() => {
    // Embed should only be enabled if we're in an iframe
    setIsDisabled(window.self === window.top);
  }, []);

  if (isDisabled === null) {
    return <EmbeddedChatbotFallback />;
  }

  if (isDisabled) {
    return isPopup ? (
      <ChatbotDisabledEmbeddedPopup />
    ) : (
      <ChatbotDisabledEmbedded />
    );
  }

  return (
    <ChatbotProvider>
      {isPopup ? (
        <EmbeddedChatbotBlockPopup
          {...props}
          fallback={<EmbeddedChatbotFallback />}
        />
      ) : (
        <EmbeddedChatbotBlock {...props} />
      )}
    </ChatbotProvider>
  );
}
